export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11534.04c3bec8.jpg";